<template>
  <div class="page-container">
    <div class="page-title-container">
      <h1 class="page-title">
        {{ editing ? "Editar vacante" : "Nueva vacante" }}
      </h1>
    </div>
    <div>
      <form class="custom-form" @submit.prevent="save" novalidate>
        <b-card
          tag="article"
          no-body
          style="max-width: 760px"
          class="custom-card"
        >
          <b-card-header
            header-tag="section"
            class="custom-card-header d-flex align-items-center"
          >
            <h3>
              {{
                editing
                  ? "Datos de la vacante"
                  : "Datos de la vacante"
              }}
            </h3>
          </b-card-header>
          <b-card-body class="custom-card-body p-0">
            <section class="form-section mb-0 border-bottom-0">
              <div>
                <h2 class="form-subtitle">Datos personales</h2>
                <p class="form-description">
                  Ingresa los datos personales del colaborador
                </p>
              </div>

              <div class="row">
                <div class="col-md-6">
                  <div class="form-group">
                    <label for="code">Código de Vacante *</label>
                    <input
                      id="code"
                      type="text"
                      v-model.trim="form.code"
                      autocomplete="off"
                      placeholder="Ingresar número de documento"
                      class="custom-form-control"
                      :class="{
                        'custom-form-control-error': $v.form.code.$error,
                      }"
                    />
                    <FormError
                      v-if="
                        $v.form.code.$error &&
                        !$v.form.code.required
                      "
                      message="Código de vacante es requerido"
                    />
                  </div>
                </div>

                <div class="col-md-6">
                  <div class="form-group">
                    <label for="role">Rol *</label>
                    <FormSelect
                      id="role"
                      v-model="form.role"
                      :items="roleList"
                      defaultOption="Elegir rol"
                      :showError="
                        $v.form.role.$error &&
                        !$v.form.role.required
                      "
                    />
                    <FormError
                      v-if="
                        $v.form.role.$error &&
                        !$v.form.role.required
                      "
                      message="Tipo de documento es requerido"
                    />
                  </div>
                </div>

                <div class="col-md-6">
                  <div class="form-group">
                    <label for="area">Área *</label>
                    <FormSelect
                      id="area"
                      v-model="form.area"
                      :items="areaList"
                      defaultOption="Elegir área"
                      :showError="
                        $v.form.area.$error &&
                        !$v.form.area.required
                      "
                    />
                    <FormError
                      v-if="
                        $v.form.area.$error &&
                        !$v.form.area.required
                      "
                      message="Área es requerida"
                    />
                  </div>
                </div>

                <div class="col-md-6">
                  <div class="form-group">
                    <label for="experience">Años de experiencia mínima requerida *</label>
                    <input
                      id="experience"
                      type="number"
                      v-model.trim="form.experience"
                      autocomplete="off"
                      placeholder="Nombres"
                      class="custom-form-control"
                      :class="{
                        'custom-form-control-error': $v.form.experience.$error,
                      }"
                    />

                    <FormError
                      v-if="$v.form.experience.$error && !$v.form.experience.required"
                      message="Nombres son requeridos"
                    />
                  </div>
                </div>

                <div class="col-md-6">
                  <div class="form-group">
                    <label for="employee">Solicitado por *</label>

                    <SearchableDropdown
                      placeholder="Elegir colaborador"
                      :options="employeeList"
                      :oldValue="form.employee"
                      @selected="form.employee = $event"
                      :show-error="
                        $v.form.employee.$error && !$v.form.employee.required
                      "
                    />

                    <FormError
                      v-if="$v.form.employee.$error && !$v.form.employee.required"
                      message="Colaborador es requerido"
                    />
                  </div>
                </div>

                <div class="col-md-12">
                  <div class="form-group">
                    <label for="details">Detalle de la vacante *</label>

                    <global-trumbowyg v-model="form.description" />

                    <FormError
                      v-if="$v.form.details.$error && !$v.form.details.required"
                      message="Detalle de la vacante es requerido"
                    />
                  </div>
                </div>

                <div class="col-md-12">
                  <div class="form-group mb-0">
                    <label for="cv">Carga de curriculum (CVs)</label>
                    <FileInput
                      class="w-100 mt-2"
                      id-file="cv"
                      :acceptFile="['.docs', '.pdf']"
                      @onChange="onFileChange"
                    />
                  </div>
                </div>
              </div>

              <div class="form-group-buttons text-right">
                <router-link
                  :to="{ name: 'job-openings-list' }"
                  class="button button-light"
                >
                  {{ editing ? "Volver" : "Cancelar" }}
                </router-link>
                <button class="button button-primary" type="submit">
                  Guardar
                </button>
              </div>
            </section>
          </b-card-body>
        </b-card>
      </form>
    </div>
  </div>
</template>

<script>
import {
  Alert,
  FormError,
  FormSelect,
  SearchableDropdown,
  Constants,
  FileInput
} from "wize-admin";

import GlobalTrumbowyg from "@/core/components/GlobalTrumbowyg"

import { EmployeeService } from "@/core/services";
import { Constants as LocalConstants } from "@/core/utils";
import { numeric, required } from "vuelidate/lib/validators";
import { mapGetters } from "vuex";

export default {
  components: {
    FormError,
    FormSelect,
    SearchableDropdown,
    FileInput,
    GlobalTrumbowyg
  },
  data() {
    return {
      loading: true,
      showCalendar: false,
      identifierTypes: [
        LocalConstants.IdentifierType.DNI,
        LocalConstants.IdentifierType.LIBRETA_MILITAR,
        LocalConstants.IdentifierType.CARNET_MILITAR,
        LocalConstants.IdentifierType.CE,
        LocalConstants.IdentifierType.PASAPORTE,
      ],
      districts: [],
      nacionalityList: [
        {
          key: 1,
          label: 'Nacionalidad 1'
        },
        {
          key: 2,
          label: 'Nacionalidad 2'
        },
        {
          key: 3,
          label: 'Nacionalidad 3'
        }
      ],
      genderList: [
        Constants.sexOptions.MALE,
        Constants.sexOptions.FEMALE
      ],
      roleList: [
        {
          key: 1,
          label: 'Rol 1',
        },
        {
          key: 2,
          label: 'Rol 2',
        },
        {
          key: 3,
          label: 'Rol 3',
        }
      ],
      employeeList: [
        {
          key: 1,
          label: 'Colaborador 1',
        },
        {
          key: 2,
          label: 'Colaborador 2',
        },
        {
          key: 3,
          label: 'Colaborador 3',
        }
      ],
      form: {
        code: null,
        role: null,
        area: null,
        experience: null,
        employee: null,
        details: null,
        description: null
      },
      editing: false,
    };
  },
  validations: {
    form: {
      code: { required },
      role: { required },
      area: { required },
      experience: { required, numeric },
      employee: { required },
      details: { required },
      description: { required }
    },
  },
  watch: {
    "$route.params.id": function () {
      if (this.$route.params.id) this.load(this.$route.params.id);
    }
  },
  computed: {
    ...mapGetters({
      user: "auth/getUser",
    }),
  },
  methods: {
    async save() {
      this.$v.$touch();
      if (this.$v.$error) {
        this.$nextTick(() => {
          this.$smoothScroll({
            scrollTo: document.querySelector(".form-error"),
            updateHistory: false,
            offset: -50,
          });
        });

        return;
      }

      try {
        this.$store.dispatch("app/loading", true);

        const data = { ...this.form };

        let response;
        if (!this.editing) response = await EmployeeService.save(data);
        else
          response = await EmployeeService.update(this.$route.params.id, data);
        Alert.success("Se almacenó la información correctamente");
        if (!this.editing) {
          this.$router.push({
            name: "job-openings-edit",
            params: { id: response.payload.id },
          });
          this.editing = true;
        }
      } catch (ex) {
        console.error(ex);
        Alert.error(ex.errors.message);
      } finally {
        this.$store.dispatch("app/loading", false);
      }
    },
    async load(id) {
      try {
        this.$store.dispatch("app/loading", true);
        const response = await EmployeeService.get(id);
        const payload = response.payload;
        this.form = {
          ...payload,
        };
        this.form.identifier = payload.identifier;
        this.editing = true;
      } catch (e) {
        console.error(e);
        Alert.error(e.errors.message);
        this.$router.push({ name: "job-openings-list" });
      } finally {
        this.$store.dispatch("app/loading", false);
        setTimeout(() => {
          this.loading = false;
        }, 1000);
      }
    },
  },
  async created() {
    if (this.$route.params.id) this.load(this.$route.params.id);
    else this.loading = false;
  },
};
</script>

<style lang="stylus" scoped></style>
